import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

// Simple singleton state so the banner + settings toggle share the same value.
let _current = null;
const _listeners = new Set();

const _notify = (v) => {
  _current = v;
  _listeners.forEach((cb) => cb(v));
};

export function useDemoMode() {
  const [active, setActive] = useState(_current);
  const [loading, setLoading] = useState(_current === null);

  useEffect(() => {
    const listener = (v) => setActive(v);
    _listeners.add(listener);
    if (_current === null) {
      api
        .get("/demo-mode")
        .then(({ data }) => _notify(!!data?.active))
        .catch(() => _notify(false))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
    return () => {
      _listeners.delete(listener);
    };
  }, []);

  const setDemoMode = useCallback(async (next) => {
    const { data } = await api.post("/demo-mode", { active: next });
    _notify(!!data.active);
    return data.active;
  }, []);

  return { active: !!active, loading, setDemoMode };
}
